// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityUserMemberships = {
  drawers: {
    membership: "Authorization · {name}",
    membershipShort: "Authorization",
  },
  alerts: {
    membershipEditMode:
      "This drawer supports full platform-role editing: keep selected roles, add new roles, and remove existing roles by unselecting them. Submit applies a diff of adds and removals.",
    membershipNoExistingRoles: "No platform roles are currently assigned.",
  },
  confirms: {
    removeMembershipTitle: "Remove Platform Role Binding",
    removeMembershipDescription: "Remove {value}?",
  },
  messages: {
    membershipRemoved: "Platform role binding removed",
    membershipRemoveFailed: "Failed to remove platform role binding",
    membershipCreated:
      "Platform role assignment completed. Added {count} roles and skipped {skippedCount} existing roles",
    membershipCreatedWithPartialFailures:
      "Platform role assignment partially completed: added {successCount}, skipped {skippedCount}, failed {failedCount}: {details}",
    membershipCreateFailed: "Failed to assign platform role",
    membershipCreateFailedForRole: "Failed to assign platform role: {role}",
    membershipAllRolesAlreadyAssigned: "All selected platform roles are already assigned",
    membershipUpdated:
      "User authorization updated. Added {createdRoleCount} platform roles, removed {removedRoleCount} platform roles, added {createdOrganizationMembershipCount} organization memberships, and removed {removedOrganizationMembershipCount} organization memberships",
    membershipUpdatedWithPartialFailures:
      "User authorization partially updated: added {createdRoleCount} platform roles, removed {removedRoleCount} platform roles, added {createdOrganizationMembershipCount} organization memberships, removed {removedOrganizationMembershipCount} organization memberships, failed {failedCount}: {details}",
    membershipUpdateFailed: "Failed to update platform role assignments",
    membershipRemoveFailedForRole: "Failed to remove platform role: {role}",
    membershipNoChanges: "Platform roles and organization memberships are unchanged",
    organizationMembershipContextUnavailable:
      "The organization context is unavailable. Initialize the organization tree before editing memberships.",
    organizationMembershipCreateFailed: "Failed to add organization membership",
    organizationMembershipRemoveFailedForUnit: "Failed to remove organization membership: {unit}",
  },
  forms: {
    organizationMembershipsHint:
      "This field maintains the user's real organization memberships and supports attaching the user to multiple organization nodes.",
    organizationMembershipsUnavailable:
      "No organization tree is available yet. Initialize the organization tree first on the organizations page.",
  },
} as const;
